import React from 'react';

const LeftSideLayout = () => (
    /* eslint-disable-next-line react/jsx-fragments */
    <React.Fragment></React.Fragment>
);

export default LeftSideLayout;
